import {Completable, pending, StringMapDTO} from 'kashable-mobile-common';

import {fetchDictionary as fetchDictionaryRequest} from '../apis/dictionary';
import {RootState} from '../store';

import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';

const INITIAL_STATE: Completable<StringMapDTO> = pending();

export const fetchDictionary = createAsyncThunk('dictionary/fetch', async (dictionary, {rejectWithValue}) => {
    const response = await fetchDictionaryRequest();

    if (response.error) {
        rejectWithValue(response);
    }

    return response;
});

export const dictionarySlice = createSlice({
    name: 'dictionary',
    initialState: INITIAL_STATE,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        clearDictionary: () => {
            return {...INITIAL_STATE};
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchDictionary.pending, () => {
                return pending();
            })
            .addCase(fetchDictionary.fulfilled, (state, action) => {
                return action.payload;
            });
    },
});

export const {
    clearDictionary,
} = dictionarySlice.actions;

export const selectDictionary = (state: RootState) => state.dictionary;
export default dictionarySlice.reducer;
